import I18n from "i18n-js";
import React from "react";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";

export default class ModalWarning extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
    };

    this.onOK = this.onOK.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  render() {
    return (
      <div className="ModalWarning modal-content" s>
        {this.renderModalHeader()}
        {this.renderModalBody()}
        {this.renderModalFooter()}
        <LoadingSpinner
          show={this.state.loading}
          style={{ left: "0px", right: "0px" }}
        />
      </div>
    );
  }

  renderModalHeader() {
    return (
      <div className="modal-header">
        <div className="modal-title">
          <h4>{this.props.title}</h4>
        </div>
        {this.props.hideHeaderClose ? null : this.props
            .hideHeaderClose ? null : (
          <div className="modal-header-help-icon-close-wrapper">
            <div className="close-icon-wrapper">
              <button
                type="button"
                className="close"
                onClick={this.onCancel}
                title={I18n.t("close_without_saving")}
              >
                <span aria-hidden={true}>&times;</span>
                <span className="sr-only">{I18n.t("close")}</span>
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }

  renderModalBody() {
    return <div className="modal-body">{this.props.body}</div>;
  }

  renderModalFooter() {
    var primary_class = "btn btn-primary";
    if (this.props.modalFooter) {
      return this.props.modalFooter;
    } else if (this.props.CancelSubmit) {
      if (this.props.disabled_buttons) {
        primary_class = "btn btn-primary disabled";
      }
      return (
        <div className="modal-footer">
          <span className="warning-modal-footer">
            <button className="btn btn-secondary" onClick={this.onCancel}>
              {I18n.t("cancel")}
            </button>
            <button className={primary_class} onClick={this.onSubmit}>
                {I18n.t("submit")}
            </button>
          </span>
        </div>
      );
    } else {
      return (
        <div className="modal-footer">
          <span className="warning-modal-footer">
            <button className="btn btn-secondary" onClick={this.onOK}>
              {this.props.singleButtonLabel
                ? this.props.singleButtonLabel
                : I18n.t("ok")}
            </button>
          </span>
        </div>
      );
    }
  }

  onOK() {
    this.setState({ loading: false }, this.props.onOK);
  }

  onSubmit() {
    this.setState({ loading: true }, this.props.onSubmit);
  }

  onCancel() {
    this.setState({ loading: false }, this.props.onCancel);
  }
}
